<template>
  <div class="item">
    <b-row class="no-gutters no-flex-grow row-header">
      <b-col cols="12" sm="6" class="item-title text-left pl-2">
        <router-link to="/">
          <font-awesome-icon icon="caret-left" />&nbsp; Regresar
        </router-link>
      </b-col>
      <b-col cols="12" sm="6" class="auction-title">Partida {{ car.item }}</b-col>
    </b-row>
    <b-row class="no-gutters main-container" :class="actualBidStatus">
      <b-col :cols="panes.pane1.cols" :md="panes.pane1.md" :sm="panes.pane1.sm" class="pane1">
        <ItemSlider
          :id="car.id"
          :model="car.model"
          :brand="car.brand"
          :make="car.make"
          :images="car.all_pictures"
          :flags="car.flags"
          :bidStatus="actualBidStatus"
        />
      </b-col>
      <b-col :cols="panes.pane2.cols" :md="panes.pane2.md" :sm="panes.pane2.sm" class="pane2">
        <PropertySheet
          :id="car.id"
          :type="car.type"
          :base="car.base"
          :cc="car.cc"
          :color="car.color"
          :fuel="car.fuel"
          :mileage="car.mileage"
          :cilinders="car.cilinders"
          :doors="car.doors"
          :keys="car.keys"
          :source="car.source"
          :code="car.code"
          :transmission="car.transmission"
          :details="car.details"
        />
      </b-col>
      <b-col v-if="showBidContainer" :cols="12" :md="2" class="bid-container">
        <div class="bid-wrapper">
          <div class="bid-wrapper-inner">
            <LiveBid :id="car.id" v-on:change-bid-status="changeBidStatus" :auction="auction" />
            <Bid
              :bid="this.actualBidValue"
              :id="car.id"
              :bidAffiliate="car.bidAffiliate"
              :code="car.code"
              :bidStatus="car.bid_status"
            />
            <BidReport
              :id="car.id"
              :code="car.code"
              :bidStatus="car.bid_status"
              :bidAffiliate="car.bidAffiliate"
              :bid="car.bid"
              :minimum="car.minimum"
              :base="car.base"
            />
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="no-gutters no-flex-grow others-wrapper">
      <b-col cols="12">
        <b-container fluid>
          <b-row>
            <b-col cols="6" md="3">
              <div v-if="car.previous && car.previous.length > 0">
                <h4 class="text-">Partida anterior</h4>
                <Car
                  :id="car.previous[0].id"
                  :code="car.previous[0].code"
                  :brand="car.previous[0].brand"
                  :make="car.previous[0].make"
                  :model="car.previous[0].model"
                  :base="car.previous[0].base"
                  :pictures_slider="car.previous[0].pictures_slider"
                  :pictures_main="car.previous[0].pictures_main"
                  :pictures_normal="car.previous[0].pictures_normal"
                  :auction="auction"
                  :bid="car.previous[0].bid"
                  :bidAffiliate="car.previous[0].bidAffiliate"
                  :bidStatus="car.previous[0].bid_status"
                />
              </div>
            </b-col>
            <b-col cols="6" md="3" offset-md="6">
              <div v-if="car.previous && car.next.length > 0">
                <h4 class="text-right">Partida siguiente</h4>
                <Car
                  :id="car.next[0].id"
                  :code="car.next[0].code"
                  :brand="car.next[0].brand"
                  :make="car.next[0].make"
                  :model="car.next[0].model"
                  :base="car.next[0].base"
                  :pictures_slider="car.next[0].pictures_slider"
                  :pictures_main="car.next[0].pictures_main"
                  :pictures_normal="car.next[0].pictures_normal"
                  :auction="auction"
                  :bid="car.next[0].bid"
                  :bidAffiliate="car.next[0].bidAffiliate"
                  :bidStatus="car.next[0].bid_status"
                />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ItemSlider from "./item/ItemSlider";
import PropertySheet from "./item/PropertySheet";
import Bid from "./item/Bid";
import LiveBid from "./item/LiveBid";
import BidReport from "./item/BidReport";
import Car from "./cars/Car";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";

library.add(faCaretLeft);

export default {
  name: "Item",
  components: {
    ItemSlider,
    PropertySheet,
    Bid,
    LiveBid,
    BidReport,
    Car
  },
  data() {
    return {
      dataBidStatus: null,
      pane1: {
        cols: 12,
        md: 6,
        sm: 7
      },
      pane2: {
        cols: 12,
        md: 4,
        sm: 5
      }
    };
  },
  props: {
    car: {
      type: Object,
      default: function() {
        return {};
      }
    },
    auction: {
      type: Number,
      defult: 0
    }
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    actualBidValue: function() {
      return this.car.bid > 0 ? this.car.bid : 0;
    },
    actualBidStatus: function() {
      return this.dataBidStatus ? this.dataBidStatus : this.car.bid_status;
    },
    showBidContainer: function() {
      return this.isLoggedIn;
    },
    panes: function() {
      return {
        pane1: {
          cols: 12,
          md: 6,
          sm: 7
        },
        pane2: {
          cols: 12,
          md: this.showBidContainer ? 4 : 6,
          sm: 5
        }
      };
    }
  },
  methods: {
    changeBidStatus: function(bidStatus) {
      if (bidStatus === "reset") {
        this.dataBidStatus = this.car.bid_status;
        return;
      }
      this.dataBidStatus = bidStatus;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/partial";

.row-header {
  a {
    color: $white;

    &:hover,
    &:focus {
      color: darken($white, 15%);
    }
  }
}

.item {
  min-height: 100%;
  display: flex;
  flex-direction: column;

  > * {
    flex: 1 0 auto;

    &.no-flex-grow {
      flex-grow: 0;
    }
  }
}

.auction-title,
.item-title {
  color: $white;
  font-size: 1.5rem;
  font-weight: $font-weight-bold;
  text-align: center;
}

.auction-title {
  background-color: $redDark;
  text-transform: uppercase;
}

.item-title {
  background-color: $red;
}

.main-container {
  position: relative;
}

.bid-wrapper {
  height: 100%;
  background-color: $white;
}

.bid-wrapper-inner {
  height: calc(100% - 15px);
  background-color: $gray-200;
  padding: 0.25rem;
}

.others-wrapper {
  background-color: $white;
}

@media (max-width: prev-viewport-max-size("md")) {
  .bid-wrapper-inner {
    height: 100%;
    padding: 0;
  }

  .off {
    .bid-container {
      order: 1;
    }

    .pane1 {
      order: 2;
    }

    .pane2 {
      order: 3;
    }
  }
}
</style>
